import { asArray, asNumber, asOptionalString, asRecord, asString, reportDtoAnomaly } from './common';

/**
 * `GET /supplier-orders/:id/pz-documents` — the PZ documents already issued
 * off a supplier order, for the read-only "Dokumenty PZ" card on the ZD's
 * Powiązania tab.
 */
export interface SupplierOrderPZDocumentSummaryDto {
  id: string;
  pzNumber: string;
  status: string;
  receiptDate: string | null;
  itemCount: number;
}

export function normalizeSupplierOrderPZDocuments(
  raw: unknown,
  entity = 'supplierOrderPZDocuments',
): SupplierOrderPZDocumentSummaryDto[] {
  return asArray(raw, (item, index) => {
    const record = asRecord(item);

    if (!record) {
      reportDtoAnomaly(`${entity}[${index}]`, 'root', item);
    }

    return {
      id: asString(record?.id),
      pzNumber: asString(record?.pzNumber),
      status: asString(record?.status),
      receiptDate: asOptionalString(record?.receiptDate) ?? null,
      itemCount: asNumber(record?.itemCount),
    };
  }).filter((document) => Boolean(document.id));
}
